import { gql } from "@apollo/client";

export const CONTRACT_STOP_FIELDS = gql`
  fragment ContractStopFields on Stop {
    id
    stopIndex
    variant
    dateTime
    location
    customLocationName
    customGooglePlusCode
    groupSize
    note
  }
`;

export const CONTRACT_ROUTE_FIELDS = gql`
  fragment ContractRouteFields on Route {
    id
    publicId
    pricing {
      id
      baseRateAmt
      driverGratuityAmt
      driverGratuityPercent
      taxAmt
      taxPercent
      tollsAmt
      meetGreetAmt
      otherName
      otherAmt
      otherPercent
      other2Name
      other2Amt
      other2Percent
      other3Name
      other3Amt
      other3Percent
      other4Name
      other4Amt
      other4Percent
      other5Name
      other5Amt
      other5Percent
      other6Name
      other6Amt
      other6Percent
      stcAmt
      stcPercent
      creditCardServiceFeeAmt
      creditCardServiceFeePercent
      totalAmt
    }
    vehicle {
      id
      name
      capacity
      description
      photos {
        id
        url
        photoIndex
      }
      vehicleType {
        typeName
        typeSlug
      }
      features {
        id
        name
        category
      }
    }
    vehicleCategory {
      id
      name
      capacity
      photos {
        url
        index
      }
    }
  }
`;

export const CONTRACT_TRIP_FIELDS = gql`
  fragment ContractTripFields on Trip {
    id
    tripNumber
    totalAmount
    totalGroupSize
    note
    stops {
      ...ContractStopFields
    }
    routes {
      ...ContractRouteFields
    }
    returnTrip {
      id
      tripNumber
      totalAmount
      totalGroupSize
      note
      stops {
        ...ContractStopFields
      }
      routes {
        ...ContractRouteFields
      }
    }
  }
  ${CONTRACT_STOP_FIELDS}
  ${CONTRACT_ROUTE_FIELDS}
`;

export const CONTRACT_OPTION_FIELDS = gql`
  fragment ContractOptionFields on ContractOption {
    id
    name
    displayOrder
    request {
      id
      orderNumber
      totalAmount
      status
      stage
      trips {
        ...ContractTripFields
      }
    }
  }
  ${CONTRACT_TRIP_FIELDS}
`;

export const CONTRACT_NOTE_FIELDS = gql`
  fragment ContractNoteFields on ContractNote {
    id
    type
    text
    createdAt
    user {
      id
      firstName
      lastName
    }
    contact {
      id
      firstName
      lastName
    }
  }
`;

export const LOAD_CONTRACT_FOR_REVIEW = gql`
  query LoadContractForReview($id: ID!) {
    loadContract(contractId: $id) {
      ... on LoadContractSuccess {
        contract {
          id
          name
          firstSentAt
          lastSentAt
          createdAt
          updatedAt
          contact {
            id
            firstName
            lastName
            email
            mobilePhone
          }
          selectedValue
          stage {
            id
            name
            isFinal
          }
          options {
            ...ContractOptionFields
          }
          externalNotes {
            ...ContractNoteFields
          }
        }
      }
      ... on LoadContractFailure {
        message
      }
    }
  }
  ${CONTRACT_OPTION_FIELDS}
  ${CONTRACT_NOTE_FIELDS}
`;

export const SELECT_CONTRACT_OPTION = gql`
  mutation SelectContractOption($input: SelectContractOptionInput!) {
    selectContractOption(input: $input) {
      result {
        ... on SelectContractOptionSuccess {
          contract {
            id
            stage {
              id
              name
              isFinal
            }
          }
        }
        ... on SelectContractOptionFailure {
          message
        }
      }
    }
  }
`;

export const DECLINE_CONTRACT = gql`
  mutation DeclineContract($input: DeclineContractInput!) {
    declineContract(input: $input) {
      result {
        ... on DeclineContractSuccess {
          contract {
            id
            stage {
              id
              name
              isFinal
            }
          }
        }
        ... on DeclineContractFailure {
          message
        }
      }
    }
  }
`;

export const ADD_CUSTOMER_CONTRACT_NOTE = gql`
  mutation AddCustomerContractNote($input: AddCustomerContractNoteInput!) {
    addCustomerContractNote(input: $input) {
      result {
        ... on AddCustomerContractNoteSuccess {
          contractNote {
            ...ContractNoteFields
          }
        }
        ... on AddCustomerContractNoteFailure {
          message
        }
      }
    }
  }
  ${CONTRACT_NOTE_FIELDS}
`;
